export default {
  product_reviews: {
    name: 'รีวิวสินค้า',
    fields: {
      score: {
        label: 'คะแนน',
      },
      full_name: {
        label: 'ชื่อผู้รีวิว',
      },
      subject: {
        label: 'หัวข้อ',
      },
      message: {
        label: 'รีวิว',
      },
      is_active: {
        label: 'ซ่อน/แสดง',
        choices: {
          active: 'แสดง',
          inActive: 'ซ่อน',
        },
      },
      create_at: {
        label: 'เวลาที่รีวิว',
      },
      product: {
        label: 'ชื่อสินค้า',
      },
      product_group: {
        label: 'ประเภทสินค้า',
      },
    },
    show: { title: 'รายละเอียดรีวิว' },
  },
}
